<li class="itb-menu-button" [ngClass]="{'cursor-notallowed': menuButton.isDisabled}" routerLinkActive="active">
    <a *ngIf="isLink" class="menu-button {{className}}" routerLink="{{link}}" routerLinkActive="active" [ngClass]="{'disabled-menu': menuButton.isDisabled}" (click)="onClick(menuButton)">
        <itb-icon [className]="menuButton.iconClassName"></itb-icon>
        <itb-text [className]="menuButton.textClassName" [text]="menuButton.name"></itb-text>
      </a>

  <a *ngIf="!isLink" class="menu-button {{className}}" [ngClass]="{'disabled-menu': menuButton.isDisabled}" (click)="onClick(menuButton)">
    <itb-icon [className]="menuButton.iconClassName"></itb-icon>
    <itb-text [className]="menuButton.textClassName" [text]="menuButton.name"></itb-text>
  </a>
  <itb-icon *ngIf="subMenu" class="sub-menu-arrow" [className]="'angle-down'" (click)="toggelSubMenu()"></itb-icon>
  <ul *ngIf="subMenu" class="sm-sub-menu" [ngClass]="{'open': isSubMenuOpen}">
    <a *ngFor="let menu of subMenu" routerLink="{{menu.linkPath}}" routerLinkActive="active"><itb-submenu-button [className]="'itb-submenu-btn'" [iconClassName] ="menu.submenuIconClassName" [text]="menu.submenuText" [hasCloseButton]=false (onClickHandler)="onSubmenuClickEvent($event)"></itb-submenu-button></a>
  </ul>
</li>
